import React from 'react';
import { Route} from 'react-router-dom';

import { PosicaoEstoque, PaginaInicial, Relatorio, EntradaNFe, Ajustes, Conferencia, Etiquetas, PaginaProdutos} from '../paginas';

import {Menu} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBoxCheck, faBoxes, faChartLine, faInventory, faBarcodeRead, faLink } from '@fortawesome/pro-light-svg-icons'
import { Link } from 'react-router-dom';
import { RelacaoProdutoFornecedor } from '../paginas/relacao-produto-fornecedor/RelacaoProdutoFornecedor';




const {SubMenu} = Menu;


const MainMenu = () => {
    return (<Menu 
        mode='inline'
        defaultSelectedKeys={['dashboard']} >

            <Menu.Item key='dashboard'  icon={<FontAwesomeIcon icon={faChartLine} /> }>
                <Link to='/'>Dashboard</Link>
            </Menu.Item>

             <Menu.Item key='produtos'  icon={<FontAwesomeIcon icon={faBoxes} /> }>
                <Link to='/produtos'>Produtos</Link>
            </Menu.Item> 

            
                 
            
            <SubMenu key="entrada" title="Entrada" icon={<FontAwesomeIcon icon={faBoxCheck} />}>
                <Menu.Item><Link to='/entrada/nfe'>Nota Fiscal</Link></Menu.Item>
            </SubMenu>

            <SubMenu key="Inventaio" title="Inventário" icon={<FontAwesomeIcon icon={faInventory} />}>
                <Menu.Item key="ajustes" title="Ajustes"><Link to='/inventario/ajustes'>Ajustes</Link></Menu.Item>
                <Menu.Item key="conferencia"><Link to='/inventario/conferencia'>Executar Conferência</Link></Menu.Item>
                <Menu.Item><Link to='/inventario/posicao-estoque'>Posição Estoque</Link></Menu.Item>
            </SubMenu>

            <Menu.Item key='produto-x-fornecedor'  icon={<FontAwesomeIcon icon={faLink} /> }>
                <Link to='/produto-x-fornecedor'>Produto x Fornecedor</Link>
            </Menu.Item>                  
            

            <Menu.Item key='etiquetas'  icon={<FontAwesomeIcon icon={faBarcodeRead} /> }>
                <Link to='/etiquetas'>Etiquetas</Link>
            </Menu.Item>                  
            

            
    </Menu>);
}



const getMainMenuRouter = () => {
    return ( <>
        <Route exact path="/" component={PaginaInicial}/>
        <Route exact path="/produtos" component={PaginaProdutos}/>
        <Route exact path="/inventario/ajustes" component={Ajustes}/>
        <Route exact path="/inventario/posicao-estoque" component={PosicaoEstoque}/>
        <Route exact path="/inventario/conferencia" component={Conferencia}/>
        <Route exact path="/entrada/nfe" component={EntradaNFe}/>
        <Route exact path="/relatorios" component={Relatorio}/>
        <Route exact path="/etiquetas" component={Etiquetas}/>
        <Route exact path="/produto-x-fornecedor" component={RelacaoProdutoFornecedor}/>
    </>);
}

export {MainMenu, getMainMenuRouter};